export default __webpack_public_path__ + "static/media/VerticalAD2.cb91916d.png";